import { Component } from '@angular/core';

@Component({
  selector: 'nb-auth',
  templateUrl: './auth.component.html',
  standalone: false,
})
export class NbAuthComponent {}
